export const TYPE_POPOVER = {
   URL: 'url',
   PHONE_NUMBER: 'phone_number',
   BLOCK: 'block',
   ICEBREAKER: 'icebreaker'
}